import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Paper,
  Avatar,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useDownloadExcel } from "react-export-table-to-excel";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../../Style/pagestyle.scss";
import FooterPagination from "../Include/FooterPagination";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { SelectAcademicYear, SelectProgramme } from "../Include/DynamicSelect";
import { GET_STUDENT_TUITION_REPORT } from "../../Schema/Report";
import ExportTuitionReport from "./ExportTuitionReport";
import { currencyFormat } from "../../Function/DynamicFn";

export default function TuitionReport() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);

  //Export to excel
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Student-tuition-report",
    sheet: "Student-Tuition-Information",
  });

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [programmeVal, setProgrammeVal] = useState({ id: "", title: "" });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [tableData, setTableData] = useState([1, 2, 3]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { refetch } = useQuery(GET_STUDENT_TUITION_REPORT, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      academicYearId: academicYearVal?.id ? academicYearVal?.id : "",
      // programmeId: programmeVal?.id ? programmeVal?.id : "",
      from: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
      to: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
    },
    onCompleted: ({ getStudentTuitionReportPagination }) => {
      // console.log(
      //   "getStudentTuitionReportPagination",
      //   getStudentTuitionReportPagination
      // );
      setTableData(getStudentTuitionReportPagination?.data);
      setPaginationData(getStudentTuitionReportPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, open, keyword, academicYearVal?.id, startDate, endDate]);

  const colors = [
    "rgb(34 197 94)",
    "rgb(37 99 235)",
    "rgb(249 115 22)",
    "rgb(250, 42, 85)",
    "rgb(255 0 0)",
    "rgb(34 197 94)",
    "rgb(37 99 235)",
    "rgb(249 115 22)",
    "rgb(250, 42, 85)",
    "rgb(255 0 0)",
  ];

  // =========================== Resize width Screen ============================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="row" spacing={2}>
          <Box className="slash" />
          <Stack direction="column" justifyContent="center">
            <Link to="/report" className="page-link-title">
              <Typography className="page-title">Report</Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">Student Tuition</Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              Student Tuition
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              Search student's name
            </Typography>
            <TextField
              placeholder={t("search")}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              Select academic year
            </Typography>

            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className={"box-date"}
            />
          </Grid>
          {/* <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">Select year</Typography>

            <SelectProgramme
              selectedVal={programmeVal}
              setSelectedVal={setProgrammeVal}
              className={"box-date"}
            />
          </Grid> */}
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              {t("thead_date")}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                className="search-field"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              {t("thead_date")}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                className="search-field"
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(newValue);
                }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={2.4}>
            <Stack direction="row" justifyContent="right">
              <Button
                className="btn-create"
                onClick={onDownload}
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
              >
                Export
              </Button>

              <ExportTuitionReport
                loading={loading}
                tableData={tableData}
                paginationData={paginationData}
                tableRef={tableRef}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead
              className="header-row"
              style={{
                backgroundColor: "red !important",
              }}
            >
              <TableCell
                className="header-title-start"
                style={{
                  width: "5% !important",
                  backgroundColor: "red !important",
                }}
              >
                {t("no")}
              </TableCell>
              <TableCell
                className="header-title"
                style={{ width: "10% !important" }}
              >
                Student ID
              </TableCell>
              <TableCell
                className="header-title"
                style={{
                  width: "15% !important",
                }}
              >
                Full name
              </TableCell>
              <TableCell
                className="header-title"
                style={{
                  width: "15% !important",
                }}
              >
                English name
              </TableCell>
              <TableCell
                className="header-title"
                style={{
                  width: "15% !important",
                }}
              >
                Gender
              </TableCell>

              <TableCell
                className="header-title"
                style={{
                  width: "15% !important",
                }}
              >
                Shift
              </TableCell>
              <TableCell className="header-title">Class name</TableCell>
              <TableCell className="header-title">Invoice number</TableCell>
              <TableCell className="header-title">Start date</TableCell>
              <TableCell className="header-title">End date</TableCell>
              <TableCell className="header-title">Paid date</TableCell>
              {/* <TableCell className="header-title" align="center">
                Income head
              </TableCell> */}
              <TableCell className="header-title">Total</TableCell>
              <TableCell className="header-title" align="center">
                Note
              </TableCell>
              <TableCell
                className="header-title-end"
                style={{
                  width: "5% !important",
                  textAlign: "center !important",
                  backgroundColor: "red !important",
                }}
              >
                Customer type
              </TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={15} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody component={Paper} className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={15} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className={"body-row"} key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.student_id?.toString()}
                            </TableCell>
                            <TableCell className="body-cell">
                              <Stack
                                direction="row"
                                spacing={1}
                                className="student-info"
                              >
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    alt={row?.first_name}
                                    src={
                                      row?.profileImg?.slice(0, 5) === "https"
                                        ? row?.profileImg
                                        : `${process.env.REACT_APP_VIEW_URL}${row?.profileImg}`
                                    }
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.lastName + " " + row?.firstName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.englishName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.gender}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.shiftName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.className}
                            </TableCell>
                            <TableCell className="body-cell" align="center">
                              {row?.invoiceNumber}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.startDate).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.endDate).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.paidDate).format("YYYY-MM-DD")}
                            </TableCell>
                            {/* <TableCell className="body-cell">
                              <Stack direction="column">
                                {row?.incomeHead?.map((data, index2) => (
                                  <Stack direction="row" key={index2}>
                                    <Typography
                                      className="income-head"
                                      style={{
                                        color: colors[index2],
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {data?.incomeName} :
                                    </Typography>
                                    <Typography
                                      className="income-head"
                                      style={{
                                        color: colors[index2],
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {"  " + "$" + currencyFormat(data?.total)}
                                    </Typography>
                                  </Stack>
                                ))}
                              </Stack>
                            </TableCell> */}
                            <TableCell className="body-cell">
                              {"$" + currencyFormat(row?.total)}
                            </TableCell>

                            <TableCell className="body-cell" align="center">
                              {row?.note}
                            </TableCell>
                            <TableCell className="body-cell-end">
                              <Stack direction="row" justifyContent="center">
                                <Box
                                  className="customer-type"
                                  align="center"
                                  style={{
                                    backgroundColor:
                                      row?.customerType === "Simple"
                                        ? "#0f81c2"
                                        : row?.customerType === "Special"
                                        ? "green"
                                        : row?.customerType === "Shareholder"
                                        ? "red"
                                        : "#F4D03F",
                                  }}
                                >
                                  {row?.customerType}
                                </Box>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          Type="student"
        />
      </Box>
    </div>
  );
}
